export { AtnDsRadioOptionsComponent as Component } from './radio-options.component'
